import { gql } from '@apollo/client';

const GET_STUDENT_CHECKLIST_OUTCOMES = gql`
  query getStudentChecklistOutcomes($where: StudentChecklistOutcomesWhereInput) {
    studentChecklistOutcomes(where: $where) {
      id
      checklistId
      score
      observationId
      studentId
      studentChecklistId
      observation {
        id
        domainId
        title
      }
    }
  }
`;

export default GET_STUDENT_CHECKLIST_OUTCOMES;
